"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var layout_utils_1 = require("../../utils/layout-utils");
var FormDraggableItem = /** @class */ (function () {
    function FormDraggableItem(meta, field) {
        this.meta = meta;
        this.field = field;
        if (field && field.getDisplayNameMultilingual()) {
            this.fieldMultilingualDisplayName = layout_utils_1.LayoutUtils.multiLingualToJson(field.getDisplayNameMultilingual());
        }
    }
    return FormDraggableItem;
}());
exports.FormDraggableItem = FormDraggableItem;
//# sourceMappingURL=form-draggable-item.js.map